import { Injectable } from "@angular/core"
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()

export class LoginGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }
  canActivate(): boolean {
    if (this.authService.loggedIn()) {
      this.router.navigate(['u']);
      return true;
    } else {
      // localStorage.clear();
      return true;
    }
  }
}
